import styled from '@emotion/styled'
import DynamicInput from '../DynamicInput'
export { StyledWarningMessage } from '../GroupEditor/GroupEditor.style'

export const StyledDynamicInput = styled(DynamicInput)`
  margin-top: 10px;
`
